import { render, staticRenderFns } from "./IbAutocomplete.vue?vue&type=template&id=5e2066c1"
var script = {}
import style0 from "./IbAutocomplete.vue?vue&type=style&index=0&id=5e2066c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports